var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticClass:"mr-25",attrs:{"to":{ name: 'chat-bot' }}},[_c('feather-icon',{staticClass:"text-body",attrs:{"icon":"MessageSquareIcon","size":"21"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }